import { ColumnSort } from "@tanstack/react-table";
import { FilterOperator, Filters, processFilterValue } from "./filters";

export const buildExportQueryParams = <T>(
  filters?: Filters<T>,
  sorting?: ColumnSort,
): URLSearchParams => {
  const params = new URLSearchParams();

  if (sorting?.id) {
    params.append("sort", sorting.desc ? `-${sorting.id}` : sorting.id);
  }

  if (filters) {
    filters.forEach(({ id, value: { filter, value } }) => {
      if (value === undefined || value === "") {
        return;
      }

      const filterKey = filter ? `${id}[${filter}]` : id;

      if (hasFilterOperators(value)) {
        const deduplicatedValues = Array.from(
          new Set(processFilterValue(value)),
        );
        deduplicatedValues.forEach((val) => {
          params.append(filterKey, val.trim());
        });
      } else {
        params.append(filterKey, value.trim());
      }
    });
  }

  return params;
};

const hasFilterOperators = (value: string): boolean => {
  const operators = [FilterOperator.AND, FilterOperator.OR];
  return operators.some((operator) => value.includes(operator));
};
